import * as React from 'react';

import { ZoomIn } from '../../../../../components/Icons';
import { ControlButton } from '../../../../../components/ControlButton';

import * as styles from './styles.css';

export interface IZoomInButtonProps {
  map: YMaps.Map;
}

export const ZoomInButton: React.FC<IZoomInButtonProps> = props => {
  const { map } = props;

  const handleZoomInClick = React.useCallback(
    (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      event.preventDefault();

      const zoom = map.getZoom();
      const [, maxZoom] = map.zoomRange.getCurrent();
      if (zoom >= maxZoom) {
        return;
      }

      return map.setZoom(zoom + 1);
    },
    [map],
  );

  return (
    <ControlButton className={styles['button']} onClick={handleZoomInClick}>
      <ZoomIn />
    </ControlButton>
  );
};
